<template>
  <div>
    <b-row>
      <b-col
          md="4"
          sm="4"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
          md="4"
          sm="4"
          class="my-1"
      >
        <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Datum"
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col
          md="4"
          sm="4"
          class="my-1"
      >
        <b-form-group

            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="float-right"
        >
          <b-button-group>
            <b-button
                size="sm"
                variant="info"
                @click="Add"
            >
              Neue Addresse
            </b-button>
            <b-button
                size="sm"
                variant="info"
                @click="OpenVList"
            >
              Preisvariationen
            </b-button>
          </b-button-group>
        </b-form-group>
      </b-col>


      <b-col cols="12">
        <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :items="items"
            :fields="fields"
            @row-clicked="Click"
        >
          <template #cell(Name)="data">
            {{ data.item.Contact.Name }}
          </template>
          <template #cell(Street)="data">
            {{ data.item.Address.Street }}, {{ data.item.Address.ZipCode }} {{ data.item.Address.Location }}
          </template>
          <template #cell(Phone)="data">
            {{ data.item.Contact.Phone }}
          </template>
          <template #cell(Info)="data">
            <feather-icon
                v-show="data.item.Contact.Email != null"
                icon="AtSignIcon"
                size="22"
                class="mr-1"
            />
            <feather-icon
                v-show="data.item.Contact.Web != null"
                icon="ChromeIcon"
                size="22"
            />

          </template>
        </b-table>
      </b-col>

      <b-col
          cols="12"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BButtonGroup
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BButtonGroup
  },
  data() {
    return {
      lastClickedRow: -1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterTimeout: null,
      fields: [
        {
          key: 'AddressId',
          label: 'Id',
        },
        {
          key: 'Name',
          label: 'Name',
        },
        {
          key: 'Street',
          label: 'Addrese',
        },
        {
          key: 'Phone',
          label: 'Telefon',
        },
        {
          key: 'Info',
          label: 'Info',
        },
      ],
      items: [],
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Adressenliste'
    })
    this.LoadList()
    this.$watch(
        () => this.currentPage,
        val => {
          this.LoadList()
        },
    )

    this.$watch(
        () => this.perPage,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
        () => this.filter,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {
    Add() {
      this.$router.push({
        name: 'Address',
        params: { id: 0 }
      })
    },
    OpenVList() {
      this.$router.push({ name: 'PriceVariationList' })
    },
    Click(record, index) {
      this.$router.push({
        name: 'Address',
        params: { id: record.AddressIdentId }
      })
    },
    LoadList() {

      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/address/list?from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url = `/address/list/filter?filter=${this.filter}`
      }
      this.$http.get(url)
          .then(resp => {
            this.totalRows = resp.data.info.fullEntries
            resp.data.list.forEach(i => {
              this.items.push(i.Value)
            })
          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    },
  },
}
</script>
